import { Link } from 'react-router-dom';

const quickLinks = [
  { label: 'Home', path: '/' },
  { label: 'Services', path: '/services' },
  { label: 'Emergency Cleanup', path: '/emergency-cleanup' },
  { label: 'Property Restoration', path: '/property-restoration' },
  { label: 'Pipe Leak & Drainage', path: '/pipe-leak-drainage' },
  { label: 'Request Service', path: '/service-request' },
  { label: 'Contact', path: '/contact' },
];

export default function Footer() {
  return (
    <footer className="bg-[#1A2332] text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8 pt-16 pb-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://static.readdy.ai/image/950b0b3f1f9eed6b6b77e430ea7654eb/7148e27a836d270da7b9e8979d76c8d6.jpeg"
                alt="MRS Logo"
                className="h-12 w-12 rounded-lg object-cover"
              />
              <div>
                <p className="font-bold text-sm leading-tight">Mitigation Restoration</p>
                <p className="text-xs text-gray-400 leading-tight">Services</p>
              </div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              Certified professionals delivering fast, reliable damage mitigation and full property restoration services — available 24/7.
            </p>
            <div className="flex items-center gap-3 mt-5">
              {['ri-facebook-fill', 'ri-twitter-x-fill', 'ri-instagram-line', 'ri-linkedin-fill'].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-[#DC2626] transition-colors cursor-pointer"
                >
                  <i className={`${icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-gray-400 mb-5">Quick Links</h4>
            <ul className="space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-gray-300 text-sm hover:text-white transition-colors cursor-pointer flex items-center gap-2"
                  >
                    <i className="ri-arrow-right-s-line text-[#DC2626]"></i>
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-gray-400 mb-5">Our Services</h4>
            <ul className="space-y-2.5">
              {[
                'Damage Assessment',
                'Water Damage Cleanup',
                'Fire & Smoke Restoration',
                'Mold Remediation',
                'Pipe Leak Repair',
                'Drainage Cleaning',
                'Structural Drying',
              ].map((s) => (
                <li key={s} className="text-gray-300 text-sm flex items-center gap-2">
                  <i className="ri-checkbox-circle-fill text-[#DC2626] text-xs"></i>
                  {s}
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-gray-400 mb-5">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#DC2626]/20 mt-0.5 shrink-0">
                  <i className="ri-phone-fill text-[#DC2626] text-sm"></i>
                </div>
                <div>
                  <p className="text-white text-sm font-semibold">+1 (800) 555-1234</p>
                  <p className="text-gray-400 text-xs">24/7 Emergency Line</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#DC2626]/20 mt-0.5 shrink-0">
                  <i className="ri-mail-fill text-[#DC2626] text-sm"></i>
                </div>
                <div>
                  <p className="text-white text-sm font-semibold">info@mrsrestore.com</p>
                  <p className="text-gray-400 text-xs">Email Support</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#DC2626]/20 mt-0.5 shrink-0">
                  <i className="ri-map-pin-fill text-[#DC2626] text-sm"></i>
                </div>
                <div>
                  <p className="text-white text-sm font-semibold">1234 Restoration Ave</p>
                  <p className="text-gray-400 text-xs">Houston, TX 77001</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-gray-500 text-xs">
            &copy; {new Date().getFullYear()} Mitigation Restoration Services. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-gray-500 text-xs hover:text-gray-300 cursor-pointer">Privacy Policy</a>
            <a href="#" className="text-gray-500 text-xs hover:text-gray-300 cursor-pointer">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
